import { Col, Row } from "antd";
import { ReactElement } from "react";
import { down, up } from "styled-breakpoints";
import styled from "styled-components";
import { Headline } from "sunday-component";
import { useRouter } from "next/router";
import { ProductCategory as ProductCategoryType } from "../../types/productCategory";
import LandingPageRetailCategoryCard, {
  getLandingPageRetailProductCategoryCard,
} from "../CategoryCard/LandingPageRetailCategoryCard/LandingPageRetailCategoryCard";

const Container = styled(Row)`
  justify-content: center;
`;
const TitleDesktop = styled(Headline)<{
  titleColor: string;
}>`
  ${down("md")} {
    display: none;
  }
  text-align: center;
  margin-bottom: 40px;
  color: ${(props) => props.titleColor};
`;
const TitleMobile = styled(Headline)<{
  titleColor: string;
}>`
  ${up("lg")} {
    display: none;
  }
  font-size: 24px;
  margin-top: 24px;
  text-align: center;
  margin-bottom: 40px;
  color: ${(props) => props.titleColor};
`;

const ProductContainer = styled.div`
  max-width: var(--content-max-width);
  margin: auto;
  display: grid;
  grid-gap: 24px 16px;
  justify-content: center;
  padding: initial;
  ${down("sm")} {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 16px 16px;
  }
  ${up("md")} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${up("lg")} {
    grid-template-columns: repeat(3, 1fr);
  }
  ${up("xl")} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const ProductCategoryContainer = styled.div<{
  bgColor: string;
}>`
  ${down("md")} {
    background: ${(props) => props.bgColor};
    padding: 40px 16px 80px 16px;
    border: initial;
    box-shadow: initial;
    border-radius: initial;
    max-width: 938px;
  }
  margin: auto;
  padding: 80px 58px 80px 58px;
  background: ${(props) => props.bgColor};
`;

export type ProductCategoryProps = {
  isLoading: boolean;
  productCategories: ProductCategoryType[];
  channelPath: string;
  isRET: boolean;
  content: any;
};

const ProductList = ({
  isLoading,
  productCategories,
  channelPath,
  content,
  isRET,
}: ProductCategoryProps): ReactElement => {
  const { locale } = useRouter();

  return (
    <Container>
      <Col span={24}>
        <ProductCategoryContainer
          bgColor={content.directlink?.otherCategories?.background?.color}
        >
          <Col xs={{ span: 24 }} md={{ span: 20, offset: 2 }}>
            <TitleDesktop
              level={2}
              titleColor={content.directlink?.otherCategories?.titleTextColor}
            >
              {content.directlink.otherCategories.title[locale]}
            </TitleDesktop>
            <TitleMobile
              level={4}
              titleColor={content.directlink?.otherCategories?.titleTextColor}
            >
              {content.directlink.otherCategories.title[locale]}
            </TitleMobile>
          </Col>
          <Col span={24}>
            <ProductContainer>
              {isLoading ? (
                <>
                  <LandingPageRetailCategoryCard isLoading />
                  <LandingPageRetailCategoryCard isLoading />
                  <LandingPageRetailCategoryCard isLoading />
                </>
              ) : (
                productCategories.map((productCategory) =>
                  getLandingPageRetailProductCategoryCard({
                    productCategory,
                    channelPath,
                  })
                )
              )}
            </ProductContainer>
          </Col>
        </ProductCategoryContainer>
      </Col>
    </Container>
  );
};
export default ProductList;
